import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import Small from 'UIComponents/elements/Small';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { currentOrderedProductLevels } from 'self-service-api/constants/ProductLevels';
import { getProductFeatureShortLimitConfig, getProductFeatureLongLimitConfig } from 'self-service-api/core/utilities/getFeatureConfigs';
const TableCell = styled.td.withConfig({
  displayName: "ProductCatalogTableCell__TableCell",
  componentId: "oa78b6-0"
})(["height:40px;padding:10px 20px;width:18.75%;min-width:175px;text-align:center !important;p{margin:0;}line-height:14px;"]);
const StyledTooltipSection = styled.div.withConfig({
  displayName: "ProductCatalogTableCell__StyledTooltipSection",
  componentId: "oa78b6-1"
})(["margin-bottom:8px;&:last-child{margin-bottom:0;}"]);

const ProductCatalogTableCell = ({
  featureId,
  productLine,
  showTooltip = true,
  allProductLevels = currentOrderedProductLevels,
  currentProductLevel,
  hasFeature = false
}) => {
  const getProductFeatureLongLimit = () => {
    const sections = getProductFeatureLongLimitConfig({
      featureId,
      productLine,
      allProductLevels
    });
    if (!sections.length) return null;
    const formattedSections = [];
    sections.forEach(({
      key,
      value,
      label
    }) => {
      if (label) {
        formattedSections.push( /*#__PURE__*/_jsxs(StyledTooltipSection, {
          children: [/*#__PURE__*/_jsx("b", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: label
            })
          }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: value
          })]
        }, key));
      } else {
        formattedSections.push( /*#__PURE__*/_jsx(StyledTooltipSection, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: value
          })
        }, "pretext"));
      }
    });
    return formattedSections;
  };

  const getTableCellContent = () => {
    const shortLimitConfig = getProductFeatureShortLimitConfig({
      featureId,
      productLine,
      currentProductLevel,
      hasFeature
    });
    if (!shortLimitConfig) return null; // @ts-expect-error not migrated to TS

    const longLimitContent = getProductFeatureLongLimit({
      featureId,
      productLine,
      allProductLevels
    });
    const hasTooltip = showTooltip && longLimitContent;
    const shortLimitContent = shortLimitConfig.showCheck ? /*#__PURE__*/_jsx(UIIcon, {
      name: "success",
      size: "small"
    }) : /*#__PURE__*/_jsx(Small, {
      style: hasTooltip ? {
        cursor: 'help'
      } : {},
      children: shortLimitConfig.value && /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: shortLimitConfig.value
      })
    });
    return hasTooltip ? /*#__PURE__*/_jsx(UITooltip, {
      use: "longform",
      placement: "left",
      disabled: !showTooltip,
      title: longLimitContent,
      children: shortLimitContent
    }) : shortLimitContent;
  };

  return /*#__PURE__*/_jsx(TableCell, {
    children: getTableCellContent()
  });
};

ProductCatalogTableCell.propTypes = {
  hasFeature: PropTypes.bool,
  showTooltip: PropTypes.bool,
  allProductLevels: PropTypes.array,
  featureId: PropTypes.string.isRequired,
  productLine: PropTypes.string,
  currentProductLevel: PropTypes.string
};
export default ProductCatalogTableCell;